// Undo on the line Board activity keeps for a board an agent deleted (Features 5, 28 Oct): the board back from the
// trash whole, as Settings, Trash and backups brings it, the board in view staying in view. Once it is back, the line
// says so in place of the button; past its 30 days, Undo says it has gone. The owner's alone: a shared view never gets these lines.

import type { ID } from "../../shared/types";
import { undeleteBoard } from "../state/actions";
import { useStore } from "../state/store";
import { UndoButton } from "./UndoButton";

export function DeletedUndo({ board }: { board: ID }) {
  // back in the list, or in Archived: nothing left to undo
  const back = useStore((s) => s.boards.some((b) => b.id === board) || s.archived.some((b) => b.id === board));
  if (back) return <span className="fd-undone">Brought back</span>;
  return <UndoButton tip="Brings the board back from the trash, whole" run={() => undeleteBoard(board)} />;
}
